import styled from 'styled-components';

export const ExportWrap = styled.div`
    /* width: 100%; */
    height: 41px;
    position: relative;
    margin-left: 1rem;
`;

export const ExportContainer = styled.div`
    display: flex;
    align-items: center;
    height: 100%;
    width: 150px;
    justify-content: space-between;
    padding: 0.5rem 1rem;
    border: 1px solid #cb0c9f;
    border-radius: 8px;
    color: #344767;
    cursor: pointer;
    &:hover {
      border: 2px solid #cb0c9f;
    }
`

export const ExportValue = styled.h4`
    font-size: 0.9rem;
    color: #344767;
    margin: 0;
     &:hover {
      color:  #cb0c9f;
    }
`

export const ExportIcon = styled.div`
    display: flex; 
 
    /* margin-left: 0.5rem; */
`;

export const ExportOptions = styled.ul`
    display: flex;
    width: 100%;
    flex-direction: column;
    list-style: none;
    padding: 0;
    margin: 0;
    border: 0.5px solid #cb0c9f;
    border-radius: 8px;
    font-size: 00.9rem;
    background-color: white;
    position: absolute;
    z-index: 100;
`

export const ExportOption = styled.li`
    padding: 0.25rem 0.5rem;
    border-radius: 8px;
    margin: 0;
    color: #344767;
    cursor: pointer;

    &:hover {
      color: #cb0c9f;
    }
`